require('fslightbox');

jQuery(function($){

	$(document).ready(function(){

    // quick search regex
    var qsRegex;

    var $grid = $('.grid').imagesLoaded( function() {
        // init Isotope after all images have loaded
        $('.grid-item > a > picture > img').css({'width' : '100%', 'height' : 'auto'});

        $grid.isotope({
            // options
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer',
            },
        });
    });

    var onAnimationFinished = function(){
      
      let divs = document.querySelectorAll('.grid-item');
      var divsArray = [].slice.call(divs);
      var displayBlock = divsArray.filter(function(el) {
        return getComputedStyle(el).display != "none"
      });
      var numberOfVisibleDivs = displayBlock.length;

      if(numberOfVisibleDivs == 0){
        const p = document.getElementsByClassName('gallery-no-result');
        if(p.length == 0){
          const result = document.createElement('p');
          result.classList.add('gallery-no-result');
          result.textContent = 'Aucun résultat.';
          result.style.textAlign = 'center';
  
          const container = document.getElementById('gallery-result');
          container.appendChild(result)
        }

      } else {
        const results = document.querySelectorAll('.gallery-no-result');
        results.forEach(result => {
          result.remove();
        });
      }

      // console.log($(".grid-item[style='display:none']").length);
      $('.grid-item').each(function(i){
        if($(this).css('display').toLowerCase() == 'none'){
          let lightbox = $(this).find('a');
          lightbox.removeAttr('data-fslightbox');
          refreshFsLightbox();
        } else {
          let lightbox = $(this).find('a');
          lightbox.attr('data-fslightbox', 'gallery-lightbox');
          refreshFsLightbox();
        }
      })
    }

    $('.grid-item > a > picture > img').on('click', function(){
      fsLightboxInstances['gallery-lightbox'].open();
    })

    var $quicksearch = $('.quicksearch').keyup( debounce( function() {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope({
        filter: function() {
          return qsRegex ? $(this).text().match( qsRegex ) : true;
        } 
      });
    }, 200 ) );

    $grid.on('arrangeComplete', onAnimationFinished ); 

    $('.filters-select').on( 'change', function() {
        var filterValue = this.value;
        $grid.isotope({ 
            filter: filterValue 
        });
    });
  
    function debounce( fn, threshold ) {
      var timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout( timeout );
        var args = arguments;
        var _this = this;
        function delayed() {
          fn.apply( _this, args );
        }
        timeout = setTimeout( delayed, threshold );
      };
    }

  })
})